import { useMemo, useState, useEffect, useCallback } from 'react';
import style from './index.module.less'
import {t} from "i18next";
import {countWords} from "@/utils";

const CountWords = () => {
  /**单词数 */
  const [wordLength, setWordLength] = useState<number>(0)
  /**字符数 */
  const [charactorLength, setCharactorLength] = useState<number>(0)
  /**是否展示 */
  const [show, setShow] = useState<boolean>(false)

  /** 中文字数 */
  function checksum(chars){


    var fuhao=['，','。','；','！','：','【','】','…','？','“','”','—','·' ,'、','《' ,'》' ,'（','）' ,'￥','＠' ];//一些中文符号
    var fuhao_code=[];
    for(var j=0;j<fuhao.length;j++){
      //console.log('---##--' , fuhao[j].charCodeAt(0)  );
      fuhao_code.push(fuhao[j].charCodeAt(0));
    }

    //console.log('---22222--' , fuhao_code  );

    var sum = 0;
    for (var i=0; i<chars.length; i++){
      var c = chars.charCodeAt(i);
      //console.log('---c---' , c);
      if ((c>=0x0001 && c<=0x007e) || (0xff60<=c && c<=0xff9f)){
        //sum++;
        //一些数字、字母、英文符号等
      }else if( fuhao_code.indexOf(c) >= 0  ){
        //一些中文符号
        sum+=2;
      }else{
        sum+=2;
      }
    }

    return sum/2;
  }


  useEffect(() => {
    window.GOpenCountWords = () => {
      let text = ''
      const selection2 = window.getSelection()
      if (selection2.type === 'Range') {
        text = selection2.toString()
      } else {
        text = window.GEditor.getText()
      }
      // const words = text.match(/\w+/g);
      setWordLength(countWords(text) + countWords(window.getCardTitle()));
      // setWordLength(checksum(text))
      setCharactorLength(text.length + window.getCardTitle()?.length || 0)
      setShow(true)
    }
    return () => { delete window.GOpenCountWords }
  }, [])

  if (!show) return null

  return (
    <div className={style.CountWordsStyle} onClick={() => setShow(false)}>
      <div onClick={(e: Event) => e.stopPropagation()}>
        <h6>{t("Word static")}</h6>
        <p><span>{t("Number of character")}</span><span>{charactorLength}</span></p>
        <p><span>{t("Word count")}</span><span>{wordLength}</span></p>

      </div>
    </div>
  )
}
export default CountWords